import React from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function EarningsLadder() {
  const { language } = useLanguage();
  const t = CONTENT[language].earningsLadder;

  const icons = {
    "user-plus": <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>,
    "dollar-sign": <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
    "chart-bar": <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
  };

  return (
    <div className="bg-suncoast-primary rounded-xl p-8 text-white shadow-xl relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-16 -mt-16 pointer-events-none"></div>
      
      <h3 className="text-2xl font-bold mb-8 text-center">{t.title}</h3>
      
      <div className="space-y-8 relative">
        {/* Connector Line */}
        <div className="absolute left-6 top-8 bottom-8 w-1 bg-white/20 hidden md:block"></div>

        {t.steps.map((step, index) => (
          <div key={index} className="flex flex-col md:flex-row items-center md:items-start gap-4 relative z-10">
            <div className="w-12 h-12 rounded-full bg-suncoast-accent flex items-center justify-center flex-shrink-0 shadow-lg border-2 border-white/20">
              {icons[step.icon as keyof typeof icons]}
            </div>
            <div className="text-center md:text-left">
              <h4 className="font-bold text-lg mb-1">{step.title}</h4>
              <p className="text-suncoast-bg text-sm leading-relaxed max-w-md">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 pt-6 border-t border-white/10 text-center">
         <span className="text-xs text-suncoast-bg opacity-75">{t.note}</span>
      </div>
    </div>
  );
}
